import { useAtom } from 'jotai'
import React from 'react'

import { debugModeAtom } from '@/store/app/AppAtom.ts'
import { getAndRemovePropertyFromUrlOnce } from '@/utils/chat.ts'

export const Debug: React.FC = () => {
    const [, setDebugMode] = useAtom(debugModeAtom)
    const debug = getAndRemovePropertyFromUrlOnce('debug')
    if (debug) {
        setDebugMode(true)
    }
    return null
}
